export const listProductFeatures = `
   query listProductFeatures($filter: ProductFeaturesFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listProductFeatures(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              name
              description
              category
              status
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getProductFeature = `
   query getProductFeature($id:ID!) {
       getProductFeature(id:$id) {
        id
        name
        description
        category
        status
        createdByUsername
        created
        updated
       } 
}`;
